exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#post-list-container .pl-text img,#post-list-container img{cursor:pointer;max-height:100%;height:auto!important}#blog-container img,#event-body-container img,#latest-posts img,#post-list-container img,.latest-post img{z-index:-1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/css-loader?minimize!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/css/blogpost.css
// module id = 393
// module chunks = 4